import React, {useEffect, useState} from 'react';
import {FormProvider, useForm} from "react-hook-form";
import {getLanguage, t} from "react-switch-lang";
import SelectInfinite from '../../../../../components/FormFields/SelectInfinite'
import * as yup from "yup";
import {Row, Col, Spinner} from 'react-bootstrap';
import {yupResolver} from "@hookform/resolvers";
import InputText from "../../../../../components/FormFields/InputText";
import InputDate from '../../../../../components/FormFields/inputDate/InputDate'
import TextArea from "../../../../../components/FormFields/Textarea";
import {format, parseISO} from 'date-fns';
import {
  createBankRiskProfile, editBankRiskProfile,
  getBankRiskProfile, getBankRiskProfileOverallRiskAssessmentLevel,
} from '../../../../../services/externalizations/bankRiskProfileService';
import {Toast} from "../../../../../utils/sweetAlert";
import {useParams} from 'react-router-dom';
import {
  customStyles,
  handleCancelExternalization,
  isUserReviewer, statusesOfVerification,
} from '../../../../../utils/externalizationFormOptions';
import Swal from 'sweetalert2';
import {useExternalizationContext} from '../../../../../contexts/ExternalizationContext';
import {useUserContext} from '../../../../../contexts/UserContext';
import FormActionButtons from '../../../components/formActionButtons/FormActionButtons';
import VerifyExternalizationModal from '../../../components/verifyExternalizationModal/VerifyExternalizationModal';

function SurForm({cycleId, isLastCycle, isEditAllowedByStatus, isVerified, externalizationFormConfigData}) {
    const [disabled, setDisabled] = useState(false);
    const [surFormId, setSurFormId] = useState(false);
    const [loading,setLoading] = useState(false);
    const [isReview,setIsReview] = useState(false);
    const [populated,setPopulated] = useState(false);
    const [showEditBtn,setShowEditBtn] = useState(false);
    const [defaultData,setDefaultData] = useState([]);
  const [totalRiskAssessment, setTotalRiskAssessment] = useState([])
  const [riskDescription, setRiskDescription] = useState('');
  const {id} = useParams()
  const [edit,setEdit] = useState(showEditBtn);
  const externalizationConfigData = useExternalizationContext();
  const user = useUserContext()
  const [responsibleUserId, setResponsibleUserId] = useState()
  const [verifyModalOpen, setVerifyModalOpen] = useState(false);
  const [verificationStatus, setVerificationStatus]= useState('')
  const canVerify = verificationStatus === 'PENDING'
  const userCanVerifyForm = user?.id === responsibleUserId;

  const toggleVerifyModal = () => setVerifyModalOpen(prev => !prev);
    const schema = yup.object().shape({
      processingDate: yup.date()
        .nullable()
        .typeError(t('message.fieldRequired'))
        .required(t('message.fieldRequired')),
      maturityMismatchRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
      creditRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
      operationalRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
      currencyRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
      strategicRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
      countryRiskLevel: yup.object().nullable().required(t('message.fieldRequired')),
      capitalImpactLevel: yup.object().nullable().required(t('message.fieldRequired')),
        comment: yup
            .string()
            .trim()
            .max(2000, t('message.max', {max: 2000}))
    });

    const methods = useForm({
        resolver: yupResolver(schema),
    });
    const {handleSubmit, setValue, watch, reset} = methods;
    const lang = getLanguage();

    const maturityMismatchRiskLevel = watch('maturityMismatchRiskLevel');
    const creditRiskLevel = watch('creditRiskLevel');
    const operationalRiskLevel = watch('operationalRiskLevel');
    const currencyRiskLevel = watch('currencyRiskLevel');
    const strategicRiskLevel = watch('strategicRiskLevel');
    const countryRiskLevel = watch('countryRiskLevel');
    const capitalImpactLevel = watch('capitalImpactLevel');
    const bankRiskProfileOverallRiskAssessmentLevel = watch('bankRiskProfileOverallRiskAssessmentLevel');
    const submitForm = async (data) => {
            const formatProcessingDate = format(new Date(data?.processingDate), 'yyyy-MM-dd');
            setDisabled(true);
            const dataToSubmit = {
              ...(edit && {
                id: defaultData?.id ? defaultData?.id : surFormId,
              }),
                processingDate: formatProcessingDate,
                comment: data?.comment,

              maturityMismatchRiskLevel: {id: data?.maturityMismatchRiskLevel.value},
              creditRiskLevel: {id: data?.creditRiskLevel.value},
              operationalRiskLevel: {id: data?.operationalRiskLevel.value},
              currencyRiskLevel: {id: data?.currencyRiskLevel.value},
              strategicRiskLevel: {id: data?.strategicRiskLevel.value},
              countryRiskLevel: {id: data?.countryRiskLevel.value},
              capitalImpactLevel: {id: data?.capitalImpactLevel.value},
              bankRiskProfileOverallRiskAssessmentLevel: {id: data?.bankRiskProfileOverallRiskAssessmentLevel?.value},
              formConfig: externalizationFormConfigData,
              populated: true,
              cycle: {id: parseInt(cycleId)},
              userInCharge: {id: externalizationFormConfigData?.defaultDepartment?.userInChargeForExternalizationId},
              responsibleUser: {id: externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId}
            }
            if(edit) {
              try{
                const res = await editBankRiskProfile(defaultData?.id ? defaultData?.id : surFormId,dataToSubmit)
                    if (res?.status === 200) {
                        Toast.fire({
                            title: t('message.updateSuccess2', {
                                entity: t('externalization.SURForm.bankRiskProfileForm'),
                            }),
                            icon: 'success',
                        });
                      const newVerificationStatus = res?.data?.verificationStatus;
                      if (newVerificationStatus && newVerificationStatus !== verificationStatus) {
                        setTimeout(() => {
                          window.location.reload();
                        }, 800);
                      } else {
                        setVerificationStatus(newVerificationStatus);
                        setDisabled(true);
                      }
                    }
                  setDisabled(true);
                } catch (err){
                if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
                  Swal.fire({
                    text:
                      lang === 'eng'
                        ? err.response.data.description
                        : t('message.responsibleUserForExternalizationMissing'),
                    icon: 'error',
                  });
                  setDisabled(false)
                  setEdit(false)
                } else {
                  Toast.fire({
                    title: t('message.errorApi'),
                    icon: 'error',
                  });
                }
              }
            }else {
              try {
                const response = await createBankRiskProfile(dataToSubmit)
                    if (response?.status === 201) {
                        Toast.fire({
                            title: t('message.addSuccess2', {
                                entity: t('externalization.SURForm.bankRiskProfileForm'),
                            }),
                            icon: 'success',
                        });
                        setDisabled(true)
                        setEdit(true)
                        setIsReview(true);
                      setVerificationStatus('PENDING')
                      setSurFormId(response?.data?.id)
                      setResponsibleUserId(externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId);
                    }
                }      catch (err){
                if (err?.response?.data?.code === 'responsible-user-for-externalization-is-missing') {
                  Swal.fire({
                    text:
                      lang === 'eng'
                        ? err.response.data.description
                        : t('message.responsibleUserForExternalizationMissing'),
                    icon: 'error',
                  });
                  setDisabled(false)
                  setEdit(false)
                } else {
                  Toast.fire({
                    title: t('message.errorApi'),
                    icon: 'error',
                  });
                }
              }
            }
        }
  const values = [
    maturityMismatchRiskLevel?.value,
    creditRiskLevel?.value,
    operationalRiskLevel?.value,
    currencyRiskLevel?.value,
    strategicRiskLevel?.value,
    countryRiskLevel?.value,
    capitalImpactLevel?.value,
  ].filter(v => v != null);
  const rawMaxValue = values.length ? Math.max(...values) : null;
  const maxValue = rawMaxValue != null ? rawMaxValue - 1 : null;

  useEffect(() => {
    async function fetchRiskLevels() {
      const {data} = await getBankRiskProfileOverallRiskAssessmentLevel();
      const validLevels = data.filter(r => r.value >= 0 && r.value <= 2);
      setTotalRiskAssessment(validLevels);
    }
    fetchRiskLevels();
  }, []);
  function getRiskAssessmentDTO(riskValue, riskLevelList) {
    return riskLevelList.find(r => r.value === riskValue);
  }
  useEffect(() => {
    if (maxValue != null && totalRiskAssessment.length > 0) {
      const dto = getRiskAssessmentDTO(maxValue, totalRiskAssessment);
      if(dto) {
        const transformed = {
          value: dto.id,
          label: lang === 'mne' ? dto.name : dto.nameEn
        };
        setValue('bankRiskProfileOverallRiskAssessmentLevel', transformed);
      }
    }
  }, [ maturityMismatchRiskLevel,
   creditRiskLevel,
   operationalRiskLevel,
   currencyRiskLevel,
   strategicRiskLevel,
   countryRiskLevel,
   capitalImpactLevel, totalRiskAssessment]);
  useEffect(() => {
    if (bankRiskProfileOverallRiskAssessmentLevel && totalRiskAssessment.length > 0) {
      const matchedRisk = totalRiskAssessment.find(
        (item) => item.id === bankRiskProfileOverallRiskAssessmentLevel.value
      );
      if (matchedRisk) {
        setRiskDescription({
          value: matchedRisk.value,
          label: lang === 'mne' ? matchedRisk.description : matchedRisk.descriptionEn,
        });
      }
    }
  }, [bankRiskProfileOverallRiskAssessmentLevel, totalRiskAssessment]);
  useEffect(() => {
           getBankRiskProfile(cycleId).then((res) => {
              const form = res?.data?.[0] ?? null;
              if (form) {
                  setDefaultData(form);
                  setPopulated(!!form?.populated);
                  setEdit(!!form?.populated);
                  setDisabled(!!form?.populated);
                setResponsibleUserId(externalizationFormConfigData?.defaultDepartment?.userResponsibleForExternalizationId)
                setVerificationStatus(form?.verificationStatus)
                setIsReview(!!form?.populated && isUserReviewer(externalizationConfigData,user,'bankRiskProfileForm'));
                  setShowEditBtn(!form?.populated === false || !isUserReviewer(externalizationConfigData,user,'bankRiskProfileForm'));
              }   if(res.data[0]?.populated) {
               setPopulated(false);
               setEdit(true);
             }else {
               setValue('processingDate', new Date());
               setEdit(false)
               setDisabled(!isUserReviewer(externalizationConfigData,user,'bankRiskProfileForm'));
             }
           })
    }, [id]);
  useEffect(() => {
    reset({
      bankRiskProfileOverallRiskAssessmentLevel: (
        defaultData?.bankRiskProfileOverallRiskAssessmentLevel &&
        totalRiskAssessment.length > 0
      ) ? {
        value: defaultData.bankRiskProfileOverallRiskAssessmentLevel.id,
        label:
          lang === "mne"
            ? defaultData.bankRiskProfileOverallRiskAssessmentLevel.name
            : defaultData.bankRiskProfileOverallRiskAssessmentLevel.nameEn
      } : null,
      maturityMismatchRiskLevel: defaultData?.maturityMismatchRiskLevel ?
        {
          value: defaultData.maturityMismatchRiskLevel.id,
          label:  lang === "mne"
            ? defaultData.maturityMismatchRiskLevel.name :
            defaultData.maturityMismatchRiskLevel.nameEn
        } : null,
      creditRiskLevel: defaultData?.creditRiskLevel ?
        {
          value: defaultData.creditRiskLevel.id,
          label: lang === "mne"
            ? defaultData.creditRiskLevel.name :
            defaultData.creditRiskLevel.nameEn
        } : null,
      operationalRiskLevel: defaultData?.operationalRiskLevel ?
        {
          value: defaultData.operationalRiskLevel.id,
          label: lang === "mne"
            ? defaultData.operationalRiskLevel.name :
            defaultData.operationalRiskLevel.nameEn
        } : null,
      currencyRiskLevel: defaultData?.currencyRiskLevel ?
        {
          value: defaultData.currencyRiskLevel.id,
          label: lang === "mne"
            ? defaultData.currencyRiskLevel.name :
            defaultData.currencyRiskLevel.nameEn
        } : null,
      strategicRiskLevel: defaultData?.strategicRiskLevel ?
        {
          value: defaultData.strategicRiskLevel.id,
          label: lang === "mne"
            ? defaultData.strategicRiskLevel.name :
            defaultData.strategicRiskLevel.nameEn
        } : null,
      countryRiskLevel: defaultData?.countryRiskLevel ?
        {
          value: defaultData.countryRiskLevel.id,
          label: lang === "mne"
            ? defaultData.countryRiskLevel.name :
            defaultData.countryRiskLevel.nameEn
        } : null,
      capitalImpactLevel: defaultData?.capitalImpactLevel ?
        {
          value: defaultData.capitalImpactLevel.id,
          label: lang === "mne"
            ? defaultData.capitalImpactLevel.name :
            defaultData.capitalImpactLevel.nameEn
        } : null,
      processingDate: defaultData?.processingDate
      ? parseISO(defaultData.processingDate)
      : new Date()
  })
  }, [defaultData]);

    if (loading) {
        return (
            <div className="text-center mt-4 mb-4">
                <Spinner animation="border" role="status" />
            </div>
        );
    }
    return (<>
      <FormActionButtons
        isReview={isReview}
        edit={edit}
        disabled={disabled}
        isLastCycle={isLastCycle}
        isEditAllowedByStatus={isEditAllowedByStatus}
        userCanVerifyForm={userCanVerifyForm}
        canVerify={canVerify}
        toggleVerifyModal={toggleVerifyModal}
        setDisabled={setDisabled}
      />
      <FormProvider {...methods}>
            <form onSubmit={handleSubmit(submitForm)}>
                <Row className="mb-5 w-100">
                    <Col className="col-6 col-xl-3">
                        <label className="label w-100 mt-2">
                            {t('departments.department')}
                        </label>
                      <SelectInfinite
                        api="departments"
                        name="departmentInCharge"
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={true}
                        defaultValue={
                          externalizationFormConfigData?.defaultDepartment
                            ? {
                              value: externalizationFormConfigData?.defaultDepartment?.id,
                              label:
                                lang === 'mne'
                                  ? externalizationFormConfigData?.defaultDepartment?.name
                                  : externalizationFormConfigData?.defaultDepartment?.nameEn,
                            }
                            : null
                        }
                      />
                      <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.date')}
                      </label>
                      <InputDate
                        name="processingDate"
                        className={'date-input'}
                        defaultValue={defaultData?.processingDate !== undefined ? format(new Date(defaultData?.processingDate), 'yyyy-MM-dd') : new Date()}
                        disabled={disabled}
                      />
                    </Col>
                    <Col className="col-6 col-xl-3">
                        <label className="label w-100 mt-2" htmlFor="liquidityRisk">
                            {t(`externalization.SURForm.liquidityRisk`)}
                        </label>
                      <SelectInfinite
                        api="maturity-mismatch-risk-levels"
                        name="maturityMismatchRiskLevel"
                        placeholder={t(`externalization.SURForm.placeholder.liquidityRisk`)}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        hasTooltipDescription={true}
                        defaultValue={defaultData?.maturityMismatchRiskLevel?.name}
                        isDisabled={disabled}/>
                      <label className="label w-100 mt-2" htmlFor='creditRisk'>
                        {t(`externalization.SURForm.creditRisk`)}
                      </label>
                      <SelectInfinite
                        api="maturity-mismatch-risk-levels"
                        name="creditRiskLevel"
                        placeholder={t(`externalization.SURForm.placeholder.creditRisk`)}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        hasTooltipDescription={true}
                        defaultValue={defaultData?.creditRiskLevel?.name}
                        isDisabled={disabled}/>
                      <label className="label w-100 mt-2" htmlFor='financialStatementDeficiencyRisk'>
                        {t(`externalization.SURForm.operationalRisk`)}
                      </label>
                      <SelectInfinite
                        api="operational-risk-levels"
                        name="operationalRiskLevel"
                        placeholder={t(`externalization.SURForm.placeholder.operationalRisk`)}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        hasTooltipDescription={true}
                        defaultValue={defaultData?.operationalRiskLevel?.name}
                        isDisabled={disabled}/>
                      <label className="label w-100 mt-2" htmlFor='foreignExchangeRisk'>
                        {t(`externalization.SURForm.foreignExchangeRisk`)}
                      </label>
                      <SelectInfinite
                        api="currency-risk-levels"
                        name="currencyRiskLevel"
                        placeholder={t(`externalization.SURForm.placeholder.foreignExchangeRisk`)}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        hasTooltipDescription={true}
                        defaultValue={defaultData?.currencyRiskLevel?.name}
                        isDisabled={disabled}/>
                      <label className="label w-100 mt-2" htmlFor='strategicRisk'>
                        {t(`externalization.SURForm.strategicRisk`)}
                      </label>
                      <SelectInfinite
                        api="strategic-risk-levels"
                        name="strategicRiskLevel"
                        placeholder={t(`externalization.SURForm.placeholder.strategicRisk`)}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        hasTooltipDescription={true}
                        defaultValue={defaultData?.strategicRiskLevel?.name}
                        isDisabled={disabled}/>
                      <label className="label w-100 mt-2" htmlFor='countryRisk'>
                        {t(`externalization.SURForm.countryRisk`)}
                      </label>
                      <SelectInfinite
                        api="country-risk-levels"
                        name="countryRiskLevel"
                        placeholder={t(`externalization.SURForm.placeholder.countryRisk`)}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        hasTooltipDescription={true}
                        defaultValue={defaultData?.countryRiskLevel?.name}
                        isDisabled={disabled}/>
                      <label className="label w-100 mt-2" htmlFor='impactOnBankCapital'>
                        {t(`externalization.SURForm.impactOnBankCapital`)}
                      </label>
                      <SelectInfinite
                        api="capital-impact-levels"
                        name="capitalImpactLevel"
                        placeholder={t(`externalization.SURForm.placeholder.impactOnBankCapital`)}
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        hasTooltipDescription={true}
                        defaultValue={defaultData?.capitalImpactLevel?.name}
                        isDisabled={disabled}/>
                    </Col>
                    <Col className="col-6 col-xl-3">
                      <label className="label w-100 mt-2" htmlFor="riskssessment">
                        {t('externalization.riskProponentForm.riskAssessment')}
                      </label>
                      <SelectInfinite
                        options={totalRiskAssessment}
                        name="bankRiskProfileOverallRiskAssessmentLevel"
                        labelKey={lang === 'mne' ? 'name' : 'nameEn'}
                        className="select"
                        isDisabled={true}
                        placeholder={''}
                        styles={customStyles}
                        defaultValue={
                          defaultData?.bankRiskProfileOverallRiskAssessmentLevel?.id
                            ? {
                              value: defaultData?.bankRiskProfileOverallRiskAssessmentLevel?.id,
                              label:
                                lang === 'mne'
                                  ? defaultData?.bankRiskProfileOverallRiskAssessmentLevel?.name
                                  : defaultData?.bankRiskProfileOverallRiskAssessmentLevel?.nameEn
                            }
                            : null
                        }
                      />
                      <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.riskDesc')}
                      </label>
                      <textarea
                        key={riskDescription}
                        // className="form-control input-field"
                        value={riskDescription?.label}
                        type="text"
                        defaultValue={lang === 'mne' ? defaultData?.bankRiskProfileOverallRiskAssessmentLevel?.description : defaultData?.bankRiskProfileOverallRiskAssessmentLevel?.descriptionEn}
                        disabled={true}
                        rows={4}
                      />
                      <label className="label w-100 mt-2">
                        {t('comments.comment')}
                        <span className="optional register line-height">
                  {t('common.optional')}
                </span>
                      </label>

                      <TextArea
                        name="comment"
                        className={`form-control text-area `}
                        placeholder={t('placeholder.comment')}
                        disabled={disabled}
                        defaultValue={defaultData?.comment}
                      />
                            <label className="label w-100 mt-2">
                                {t('externalization.riskProponentForm.analysisDoneBy')}
                            </label>
                      <InputText
                        type="text"
                        name="userInCharge"
                        className="form-control input-field"
                        disabled={true}
                        id="userInCharge"
                        defaultValue={externalizationFormConfigData?.defaultDepartment.userInChargeForExternalizationFullName}
                      />
                      {externalizationFormConfigData?.defaultDepartment?.deputyUserInChargeForExternalizationFullName && <>
                        <label className="label w-100 mt-2">{t('departments.userInChargeReplacementForExternalization')}</label>
                        <InputText
                          type="text"
                          name="userInChargeDeputy"
                          className="form-control input-field"
                          disabled={true}
                          id="userInCharge"
                          defaultValue={externalizationFormConfigData?.defaultDepartment?.deputyUserInChargeForExternalizationFullName}
                        /></>}
                      <label className="label w-100 mt-2">
                        {t('externalization.riskProponentForm.verificationDoneBy')}
                      </label>
                      <InputText
                        type="text"
                        name="responsibleUser"
                        className="form-control input-field"
                        disabled={true}
                        id="responsibleUser"
                        defaultValue={externalizationFormConfigData?.defaultDepartment.userResponsibleForExternalizationFullName}
                      />
                      {edit && <>  <label className="label w-100 mt-2">{t('externalization.verificationStatus')}</label>
                        <InputText
                          name="verificationStatus"
                          type="text"
                          className="form-control input-field"
                          placeholder={t( 'externalization.placeholder.verificationStatus')}
                          disabled={true}
                          defaultValue={statusesOfVerification.find(
                            (status) => status.value === verificationStatus)?.label}
                        /></>}
                    </Col>
                </Row>

                {(!edit || (edit && !disabled)) && isUserReviewer(externalizationConfigData, user, 'bankRiskProfileForm') && <Row className="mt-5 mb-3 form-footer">
                    <button
                        className="secondary-btn"
                        type="reset"
                        onClick={handleCancelExternalization}>
                        {t('buttons.cancel')}
                    </button>
                    <button className="primary-btn" disabled={disabled}>{t('buttons.save')}</button>
                </Row>}
            </form>
        </FormProvider>
      <VerifyExternalizationModal
        open={verifyModalOpen}
        formType={externalizationFormConfigData?.formKey}
        formId={defaultData?.id ? defaultData?.id : surFormId}
        isOpen={setVerifyModalOpen}
      />
    </>);
}

export default SurForm;